import React, { Fragment, useEffect, useState } from "react";

import { activeRangesApiUpsellProvider } from "../../../../lib/api/providers";
import { connect } from "react-redux";
import { Dropdown, Menu } from "antd";
import { selectRanges } from "../../../../redux/selectors/pdcsSelector";

const getActiveRangesOfOnePdcApi = ({ pdcId, token, clientId }) => {
  return activeRangesApiUpsellProvider
    .get(`/${clientId}/${pdcId}`, {
      headers: {
        Authorization: token
      }
    })
    .then(response => {
      if (Array.isArray(response.data)) {
        return response.data;
      }
      return [];
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};

const FamiliesList = ({ category, getLabelFromId }) => {
  return (
    <div style={{ backgroundColor: "white" }}>
      <div style={{ padding: 20, borderBottom: "1px solid #ddd" }}>
        <span style={{ fontSize: 14, color: "#ec841d" }}>{`${category.label} : `}</span>
        <span style={{ fontSize: 14, fontStyle: "italic", color: "#ec841d" }}>{`${getLabelFromId(
          category.rangeId
        )}`}</span>
      </div>
      <Menu>
        {category.families.map((element, index) => {
          return <Menu.Item key={index}>{`${element.label} : ${getLabelFromId(element.rangeId)}`}</Menu.Item>;
        })}
      </Menu>
    </div>
  );
};
const DisplayStrates = ({ category, getLabelFromId }) => {
  return (
    <Dropdown overlay={<FamiliesList category={category} getLabelFromId={getLabelFromId}></FamiliesList>}>
      <a className="ant-dropdown-link" onClick={e => e.preventDefault()} style={{ marginBottom: 5 }}>
        <span style={{ fontSize: 11, color: "#ec841d" }}>{`${category.label} : `}</span>
        <span style={{ fontSize: 11, fontStyle: "italic", color: "#ec841d" }}>{`${getLabelFromId(
          category.rangeId
        )}`}</span>
      </a>
    </Dropdown>
  );
};
const StratesList = ({ activeRanges = [], getLabelFromId }) => {
  return (
    <Fragment>
      {activeRanges.length > 0
        ? // for each locationType
          activeRanges.map((locationType, lt) => {
            return (
              <div key={lt}>
                {// for each location in locationType

                !Array.isArray(locationType.locations)
                  ? null
                  : locationType.locations.map((location, l) => {
                      return (
                        <div key={l} style={{ borderBottom: "1px solid #ddd" }}>
                          <span style={{ fontSize: 12 }}>{location.label}</span>
                          <Fragment>
                            {// for each category of current location
                            !Array.isArray(location.categories)
                              ? null
                              : location.categories.map((category, c) => {
                                  return (
                                    <div key={c}>
                                      <DisplayStrates
                                        category={category}
                                        getLabelFromId={getLabelFromId}
                                      ></DisplayStrates>
                                    </div>
                                  );
                                })}
                          </Fragment>
                        </div>
                      );
                    })}
              </div>
            );
          })
        : null}
    </Fragment>
  );
};

const Strates = ({ pdcId, token, clientId, ranges }) => {
  const [activeRanges, setActiveRanges] = useState([]);
  const getLabelFromId = id => {
    const range = ranges.find(range => range.id == id) || {};
    return range.label || "N/C";
  };
  const fetchActiveRanges = async () => {
    const data = await getActiveRangesOfOnePdcApi({ pdcId, token, clientId });
    if (Array.isArray(data)) {
      setActiveRanges(data);
    }
  };
  useEffect(() => {
    fetchActiveRanges();
  }, []);
  return (
    <div>
      <StratesList activeRanges={activeRanges} getLabelFromId={getLabelFromId}></StratesList>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    clientId: state.currentClient ? state.currentClient.id : null,
    ranges: selectRanges(state)
  };
};

export default connect(mapStateToProps)(Strates);



// WEBPACK FOOTER //
// src/containers/metier/pdcs/pdcs.utils/activeRanges.js